export default __webpack_public_path__ + "static/media/ic_ftm_24.cac4d3a4.svg";